import React from 'react';
import { motion } from 'framer-motion';
import { DateInfo } from '@/types';

interface DateDisplayProps {
  dateInfo: DateInfo;
}

export const DateDisplay: React.FC<DateDisplayProps> = ({ dateInfo }) => {
  return (
    <header className="pt-8 md:pt-16 pb-4">
      <div className="container mx-auto px-4 text-center">
        {/* Month and Day */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="text-white text-lg md:text-xl font-light mb-2"
          style={{
            textShadow: '0 2px 20px rgba(0, 0, 0, 0.5), 0 0 40px rgba(0, 0, 0, 0.3)'
          }}
        >
          {dateInfo.monthDay}
        </motion.div>
        
        {/* Week and Lunar */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-white text-sm md:text-base opacity-80 mb-6"
          style={{
            textShadow: '0 2px 20px rgba(0, 0, 0, 0.5), 0 0 40px rgba(0, 0, 0, 0.3)'
          }}
        >
          {dateInfo.weekDay} · {dateInfo.lunar}
        </motion.div>
        
        {/* Large Date Number */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.3, type: 'spring', stiffness: 100 }}
          className="text-white text-8xl md:text-9xl font-light mb-8"
          style={{
            textShadow: '0 2px 20px rgba(0, 0, 0, 0.5), 0 0 40px rgba(0, 0, 0, 0.3)'
          }}
        >
          {dateInfo.dateNumber}
        </motion.div>
      </div>
    </header>
  );
};